import { NotificationConfiguration } from '../notification.templates';

export const RACI_RESPONSIBLE_FINALIZE_TEMPLATE: NotificationConfiguration = {
  inapp: `You are responsible for a new decision.`,
  email: {
    ctaKey: 'Go to decision',
  },
};
